module.exports = __webpack_public_path__ + "img/81_theRichGetFilthier.1881740b.jpg";